import React, { memo, useCallback, useMemo } from 'react';
import { View, Platform, Keyboard } from 'react-native';
import { useSafeAreaFrame } from 'react-native-safe-area-context';
import { rem } from 'design-system/values';
import { NavigationHeader } from 'design-system/NavigationHeader';
import SelectorControllableReanimated from 'design-system/SelectorControllableReanimated';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const StockAlertScreenHeader = ({ scrollX, scrollY, horizontalScrollViewRef }) => {
    const styles = useStyles(styleSet);
    const { width } = useSafeAreaFrame();
    const sections = useMemo(() => [
        { name: 'Pending', width: rem(91) },
        { name: 'Triggered', width: rem(101) },
    ].map((item) => ({
        ...item,
        id: item.name,
        text: item.name,
    })), []);
    const handleSelectorPress = useCallback((index) => {
        Keyboard.dismiss();
        horizontalScrollViewRef.current?.scrollTo({ x: index * width, y: 0 });
    }, [horizontalScrollViewRef, width]);
    return (<NavigationHeader title="Price alerts" scrollY={scrollY} withFrame>
      <View style={styles.selectorContainer}>
        <SelectorControllableReanimated scrollX={scrollX} sections={sections} screenWidth={width} selectorStyle={styles.selectorStyle} itemContainerStyle={styles.itemContainerStyle} setSelection={handleSelectorPress}/>
      </View>
    </NavigationHeader>);
};
export default memo(StockAlertScreenHeader);
const paddingHorizontal = rem(16);
const styleSet = createStyleSheets(() => ({
    safeAreaContainer: {
        left: 0,
        right: 0,
        position: 'absolute',
        ...Platform.select({
            ios: {
                borderBottomWidth: 0,
                shadowColor: 'rgba(19, 48, 104, 0.12)',
                shadowOffset: { width: 0, height: rem(8) },
                shadowRadius: rem(32),
            },
        }),
    },
    headerContainer: {
        paddingHorizontal,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    row: { flexDirection: 'row', padding: rem(16) },
    selectorContainer: {
        flexDirection: 'row',
        paddingHorizontal: rem(16),
        paddingBottom: rem(12),
    },
    itemContainerStyle: {
        padding: 0,
        margin: 0,
    },
    selectorStyle: {
        borderRadius: rem(8),
        justifyContent: 'center',
        padding: 0,
        margin: 0,
    },
}));
